import { render, staticRenderFns } from "./Jobauth.vue?vue&type=template&id=5d57822c&scoped=true"
import script from "./Jobauth.vue?vue&type=script&lang=js"
export * from "./Jobauth.vue?vue&type=script&lang=js"
import style0 from "./Jobauth.vue?vue&type=style&index=0&id=5d57822c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d57822c",
  null
  
)

export default component.exports